import { getVacationDataByPeriod,saveRequestService } from '../../shared/data-services/vacation-request-service';



export async function loadVacationPeriods(params) {
    const response = await getVacationDataByPeriod(params);
    const data = response.data;

    return data.periods.map(p => ({
        startDate: p.dateFrom,
        endDate: p.dateTo === "0001-01-01" ? null : p.dateTo,
        slots: p.totalSlot,
        periodId: p.periodId,
        campaignId: p.campaignId,
        onRequest: data.onRequest // 👈 agregar el campo en cada item
    }));
}


export async function saveVacationRequest(payload) {
    return await saveRequestService(payload);
}


